export type KlaviyoClient = {
    email?: string;
    phone?: string;
    properties?: Record<string, string>;
};

export class Klaviyo {
    pubApiKey: string;
    listId: string;

    constructor(pubApiKey: string, listId: string) {
        this.pubApiKey = pubApiKey;
        this.listId = listId;

        if (this.pubApiKey.length === 0 || this.listId.length === 0) {
            console.error(
                "[shpln-quiz] Unable to complete Klaviyo integration: one of the required fields is empty: pubApikey, listId",
                { pubApiKey, listId },
            );
        }
    }

    async subscribeClient(client: KlaviyoClient) {
        if (client.email == null && client.phone == null) {
            console.error(
                "[shpln-quiz] Unable to subscribe to Klaviyo: email and phone are null.",
            );
            return;
        }

        const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.pubApiKey}`;
        const options = {
            method: "POST",
            headers: {
                revision: "2024-05-15",
                "content-type": "application/json",
            },
            body: JSON.stringify({
                data: {
                    type: "subscription",
                    attributes: {
                        custom_source: "Shoplanding Game",
                        profile: {
                            data: {
                                type: "profile",
                                attributes: {
                                    email: client.email,
                                    phone_number: client.phone,
                                },
                            },
                        },
                        properties: client.properties,
                    },
                    relationships: {
                        list: { data: { type: "list", id: this.listId } },
                    },
                },
            }),
        };

        const res = await fetch(url, options);

        if (res.ok) {
            return;
        }

        console.error(
            `[shpln-quiz] Failed to subscribe to Klaviyo.\nResponse Status: ${res.status} ${res.statusText}\nResponse Body:\n${await res.text()}`,
        );
    }
}
